
  import {Component, Vue, Watch, Prop} from 'vue-property-decorator';
  import iconHandler from './icon-handler.vue';

  @Component({
    components: {
      iconHandler,
    },
  })
  export default class MjText extends Vue {
    @Prop({type: Object, default: {}}) private element!: any;

    private text: string = 'Example text';
    private dialog: boolean = false;
    private settings: any = {
      'padding-top': '10px',
      'padding-bottom': '10px',
      'padding-left': '25px',
      'padding-right': '25px',
    };

    private editElement() {
      this.dialog = true;
    }

    private created() {
      this.text = this.element.data;
      this.settings = JSON.parse(JSON.stringify(this.element.settings));
    }

    @Watch('dialog')
    private updatedDialog() {
      this.$emit('updateSettings', this.settings);
    }

    @Watch('text')
    private updatedText() {
      this.$emit('updateContent', this.text);
    }
  }
